import { Type, Injectable } from "@angular/core";
import { FormGroup } from "@angular/forms";

import { EntityBuilderItem } from "./entity-builder-item";
import { StringFormComponent } from "../components/dynamic-components/string-form.component";
import { StringComponent } from "../components/dynamic-components/string.component";
import { BoolFormComponent } from "../components/dynamic-components/bool-form.component";
import { BoolComponent } from "../components/dynamic-components/bool.component";
import { NumberFormComponent } from "../components/dynamic-components/number-form.component";
import { NumberComponent } from "../components/dynamic-components/number.component";
import { ArrayFormComponent } from "../components/dynamic-components/array-form.component";
import { ArrayComponent } from "../components/dynamic-components/array.component";
import { ObjectFormComponent } from "../components/dynamic-components/object-form.component";
import { ObjectComponent } from "../components/dynamic-components/object.component";


@Injectable()
export class EbComponentItem extends EntityBuilderItem {

    createComponent(prop: any, isForm: boolean, componentData: any) {
        let propType: any;
        if (prop.type instanceof Array) {
            propType = prop.type[0];
        } else {
            propType = prop.type;
        }
        switch (propType) {
            case "string":
                this.component = (isForm) ? StringFormComponent : StringComponent;
                break;
            case "boolean":
                this.component = (isForm) ? BoolFormComponent : BoolComponent;
                break;
            case "number":
                this.component = (isForm) ? NumberFormComponent : NumberComponent;
                break;
            case "integer":
                this.component = (isForm) ? NumberFormComponent : NumberComponent;
                break;
            case "array":
                this.component = (isForm) ? ArrayFormComponent : ArrayComponent;
                break;
            case "object":
                this.component = (isForm) ? ObjectFormComponent : ObjectComponent;
                break;
        }
        this.data = componentData;
    }

    component: Type<any>;
    data: any;

    
}
